import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants/enums";
import { GetInfoBarDataResponse } from "./getInfoBarData.types";

export const requestGetInfoBarData =
  async (): Promise<GetInfoBarDataResponse> => {
    return await instance.get(ApiRoutesContent.InfoBar);
  };
